import ArrowDownIcon from "Assets/Icons/ArrowDownIcon";
import Typography from "Components/CommonComponents/Typography";
import React, { useState } from "react";
import cx from "classnames";
import {
  Option,
  MenuList,
  MultiValue,
  // ValueContainer,
  MultiValueLabel,
  MultiValueRemove,
  MultiValueContainer,
} from "Components/CommonComponents/CustomMultiSelect";
import Select from "react-select";
import "./customSelect.css";
import CrossIcon from "Assets/Icons/CrossIcon";
import styled from "styled-components";
// import IconBase from "Assets/Icons/IconBase";

const DropDownContainerDiv: any = styled<any>("div")`
  position: relative;
  width: ${(props: any) => (props.width ? props.width : "auto")};
`;
export const CustomDropdownWithSelect = (props: any) => {
  const [state, setState] = useState({
    isOpen: false,
    value: {
      label: "",
    },
  });
  const { isOpen } = state;
  const {
    value,
    isDropdownSelect,
    isSearchableDrop,
    isSearchable,
    isClearable,
    isDisabled,
    showClearIcon,
    placeholderLabel,
    closeMenuOnSelect,
    width,
  } = props;
  const newWidth =
    !isDropdownSelect && value?.label && width
      ? width + 25
      : width
      ? width
      : "auto";
  const selectStyles = {
    control: (base: any) => ({
      ...base,
      width: newWidth,
      minWidth: "180px",
      textOverflow: "ellipsis",
      whiteSpace: "normal",
      overflow: "hidden",
      fontSize: "16px",
      fontWeight: "400",
      textAlign: "center",
    }),
    option: (base: any, state: any) => ({
      ...base,
      height: "auto",
      padding: "4px 2px",
      textOverflow: "ellipsis",
      whiteSpace: "normal",
      overflow: "hidden",
      fontSize: "16px",
      fontWeight: "400",
      color: state.isSelected ? "#000000" : "inherit",
      backgroundColor: state.isSelected ? "transparent" : "inherit",
    }),
    valueContainer: (base: any) => ({
      ...base,
      width: newWidth,
      height: "30px",
      textOverflow: "ellipsis",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      whiteSpace: "normal",
      overflow: "hidden",
      borderColor: "lightgray",
      fontSize: "16px",
      fontWeight: "400",
    }),
    menu: (base: any) => ({
      ...base,
      width: newWidth,
      position: "absolute",
      borderRadius: 8,
      marginTop: 4,
      padding: "16px 0px 16px 16px",
      overflow: "hidden",
      background: "#FFFFFF",
      gap: "24px",
    }),
    menuList: (base: any) => ({
      ...base,
      overflowx: "hidden",
    }),
    singleValue: (base: any) => ({
      ...base,
      fontSize: "16px",
      fontWeight: "400",
      height: "50px",
      position: "relative",
      width: "100%",
      top: "-6px",
      color: "#545454",
    }),
    placeholder: (base: any) => ({
      ...base,
      fontSize: "16px",
      fontWeight: "400",
      color: "#545454",
      top: "-5px",
      height: "50px",
      position: "relative",
      fontFamily: "Inter-R",
    }),
  };

  const toggleOpen = () => {
    setState({ ...state, isOpen: !state.isOpen });
  };
  const onSelectChange = (val: any) => {
    if (closeMenuOnSelect && !!closeMenuOnSelect) {
      toggleOpen();
    }
    props.onChange(val);
  };

  const valuelength =
    value && Array.isArray(value) && value.length ? value.length : 0;
  const isvalueAvailable = value?.label || valuelength > 0;
  const multilabel = (label: any) => (
    <div className="d-flex flex-row justify-content-center align-items-center">
      <div className="selectedValueContainer">
        <Typography variant="body2" color="black">
          {label &&
          label.split &&
          Array.isArray(label.split("-")) &&
          label.split("-").length > 2
            ? label.split("-")[0] + "-" + label.split("-")[1]
            : label &&
              label.split &&
              Array.isArray(label.split("-")) &&
              label.split("-").length > 0
            ? label.split("-")[0]
            : label
            ? label
            : ""}
        </Typography>
      </div>

      {valuelength > 1 && (
        <div
          style={{
            padding: "1px 1px 1px 8px",
          }}
        >
          <span style={{ color: "#00b0f5" }}>+{valuelength - 1}</span>
        </div>
      )}
    </div>
  );
  const handleClearFilter = () => {
    props.onChange(null);
  };
  return isSearchableDrop ? (
    <Dropdown
      width={width}
      isOpen={isOpen}
      onClose={toggleOpen}
      target={
        <div>
          <div
            className={cx("selectedContainerStyle", {
              disabledSelectStyle: isDisabled,
              isvalueAvailableStyle: isvalueAvailable,
            })}
            onClick={() => {
              isDisabled ? {} : toggleOpen();
            }}
          >
            <div className="selectOptionInSelect">
              <Typography
                variant={
                  isDisabled ? "selectInputValueDisabled" : "selectInputValue"
                }
              >
                {value?.label
                  ? `${value.label}`
                  : value != null && Array.isArray(value) && value[0]?.label
                  ? multilabel(value[0]?.label)
                  : placeholderLabel}
              </Typography>
            </div>

            <div className="d-flex flex-row justify-content-center align-items-center">
              {!isDropdownSelect && value?.label && showClearIcon && (
                <div
                  className="mb-3 mr-1 ml-2"
                  onClick={() => {
                    handleClearFilter();
                  }}
                >
                  {" "}
                  <CrossIcon height={15} width={15} />
                </div>
              )}
              <ArrowDownIcon className="mr-1" />
            </div>
          </div>
        </div>
      }
    >
      <Select
        {...props}
        autoFocus
        backspaceRemovesValue={false}
        isSearchable={isSearchable}
        components={
          isDropdownSelect
            ? {
                Option,
                MultiValue,
                IndicatorSeparator: null,
                MenuList,
                MultiValueLabel,
                MultiValueRemove,
                MultiValueContainer,
                DropdownIndicator,
                // ValueContainer,
              }
            : { DropdownIndicator, IndicatorSeparator: null }
        }
        controlShouldRenderValue={false}
        hideSelectedOptions={false}
        placeholder={""}
        isClearable={isClearable}
        menuIsOpen
        onChange={onSelectChange}
        options={
          props.options && Array.isArray(props.options)
            ? [...props.options]
            : [{ label: "Select", value: null }]
        }
        styles={selectStyles}
        tabSelectsValue={false}
        value={props.value}
        theme={(theme) => ({
          ...theme,
          borderRadius: 8,
          colors: {
            ...theme.colors,
          },
        })}
      />
    </Dropdown>
  ) : (
    <Select
      {...props}
      autoFocus={false}
      backspaceRemovesValue={false}
      defaultMenuIsOpen={false}
      components={
        isDropdownSelect
          ? {
              Option,
              MultiValue,
              IndicatorSeparator: null,
              MenuList,
              MultiValueLabel,
              MultiValueRemove,
              MultiValueContainer,
            }
          : { IndicatorSeparator: null }
      }
      openMenuOnClick={true}
      hideSelectedOptions={false}
      isClearable={isClearable}
      isSearchable={isSearchable}
      onChange={onSelectChange}
      options={
        props.options && Array.isArray(props.options)
          ? [...props.options]
          : [{ label: "Select", value: null }]
      }
      styles={selectStyles}
      tabSelectsValue={false}
      value={props.value}
      theme={(theme) => ({
        ...theme,
        borderRadius: 8,
        borderColor: "",
        colors: {
          ...theme.colors,
        },
      })}
    />
  );
};

// styled components
interface IDropDown {
  width?: any;
  children: React.ReactNode;
  isOpen: boolean;
  target: React.ReactNode;
  onClose: () => void;
}

const Dropdown = ({ width, children, isOpen, target, onClose }: IDropDown) => (
  <DropDownContainerDiv width={width}>
    {target}
    {isOpen ? <Menu width={width}>{children}</Menu> : null}
    {isOpen ? <Paper onClick={onClose} /> : null}
  </DropDownContainerDiv>
);

const Menu = (props: any) => {
  const shadow = "hsla(218, 50%, 10%, 0.1)";
  return (
    <div
      style={{
        backgroundColor: "white",
        borderRadius: 8,
        boxShadow: `0 0 0 1px ${shadow}, 0 4px 11px ${shadow}`,
        marginTop: 8,
        position: "absolute",
        zIndex: 10000,
        width: props.width ? props.width : "auto",
      }}
      {...props}
    />
  );
};
const Paper = (props: any) => (
  <div
    style={{
      bottom: 0,
      left: 0,
      top: 0,
      right: 0,
      position: "fixed",
      zIndex: 1,
    }}
    {...props}
  />
);

const Svg = (p: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    focusable="false"
    role="presentation"
    {...p}
  />
);

export const DropdownIndicator = () => (
  <div className="dropdownIndicatorStyle">
    <Svg>
      <path
        d="M16.436 15.085l3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406zM10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </Svg>
  </div>
);
